import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SearchX, ArrowLeft, Home } from "lucide-react";

export function LoadingPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <div className="pt-40 pb-20 flex flex-col items-center justify-center">
        <div className="animate-spin w-10 h-10 border-4 border-[#1670B9] border-t-transparent rounded-full" />
        <p className="text-sm text-slate-400 mt-4">Chargement...</p>
      </div>
      <Footer />
    </div>
  );
}

export function NotFoundPage({ title = "Élément introuvable", message = "Cet élément n'est plus disponible ou a été supprimé.", backLabel = "Retour à l'accueil", backTo = "/" }) {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col" data-testid="not-found-page">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 rounded-2xl bg-[#1670B9]/10 flex items-center justify-center mx-auto mb-6">
            <SearchX className="w-10 h-10 text-[#1670B9]/60" />
          </div>
          <h1 className="font-['Quicksand'] text-2xl font-semibold text-slate-800 mb-3" data-testid="not-found-title">{title}</h1>
          <p className="text-base text-slate-500 mb-8">{message}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to={backTo} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#1670B9] text-white text-sm font-semibold hover:bg-[#0F62B3] transition-all hover:-translate-y-0.5 shadow-sm" data-testid="not-found-back-btn">
              <ArrowLeft className="w-4 h-4" /> {backLabel}
            </Link>
            {backTo !== "/" && (
              <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-slate-200 text-slate-600 text-sm font-semibold hover:bg-slate-50 transition-all" data-testid="not-found-home-btn">
                <Home className="w-4 h-4" /> Accueil
              </Link>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
